import script from "./CInputTags.vue?vue&type=script&setup=true&lang=js"
export * from "./CInputTags.vue?vue&type=script&setup=true&lang=js"

import "./CInputTags.vue?vue&type=style&index=0&id=0a42cc94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a42cc94"]])

export default __exports__